export default __webpack_public_path__ + "static/media/Accreditation-3.ec2ac3db.png";